<div
  class="notification_message"
  [ngClass]="{ active: !notification.isViewed }"
  [attr.data-id]="notification.id"
  (mouseenter)="!notification.isViewed ? onMouseEnter() : null"
  (mouseleave)="!notification.isViewed ? onMouseLeave() : null">
  <div class="message_header">
    <img src="./assets/svg/logo_notifications.svg" alt="Logo Notifications" />
    <div class="message_header_data">
      <p>{{ notification.createdAt | date: 'dd MMM yyyy, HH:mm' }}</p>
      <button mat-icon-button (click)="onDelete()">
        <img src="./assets/svg/closeBtn.svg" alt="Close" />
      </button>
    </div>
  </div>
  <div class="message_description">
    <p class="desc_text">
      {{ 'TYPE' | translate }}:
      <span class="desc_">{{ notification.processType }}</span>
    </p>
    <p class="desc_text">
      {{ 'PROCESS' | translate }}:
      <span class="desc_text">{{ notification.notificationMessageType }}</span>
    </p>
    <p class="desc_message" [innerHTML]="notification.message"></p>
    <button class="message_view" [routerLink]="notification.link">
      {{ 'VIEW' | translate }}
    </button>
  </div>
</div>
